<template>
<div class="main">
    <el-row :class="isfix?'fixed':''">
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="6">
        <div class="logo">
        <img :src="logo">
        </div>
      </el-col>
      <el-col :span="9">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" :background-color="menucolor" text-color="#586272">
            <el-menu-item index="1"><a href="http://www.e-to-china.com/">Home</a></el-menu-item>
            <el-menu-item index="2"><a href="http://www.e-to-china.com/about/">About us</a></el-menu-item>
            <el-menu-item index="3"><a href="#" @mousemove="simuHover" @mouseout="hoverNone">Products</a><ul @mousemove="simuHover" @mouseout="hoverNone" class="show" :class="active"><li><a target="_blank" href="http://hs.e-to-china.com/"> China HS Code</a></li><li><a target="_blank" href="http://cis.e-to-china.com/"> Customs Tariffs &amp; Restrictions</a></li></ul></el-menu-item>
            <el-menu-item index="4"><a href="http://www.e-to-china.com/tradetool/business.html">Plan&Price</a></el-menu-item>
            <el-menu-item index="5"><a href="/#contact-form-box">Contact us</a></el-menu-item>
          </el-menu>
      </el-col>
      <el-col :span="1">
      <el-select v-model="language" id="language" @change="changeValue($event)">
    <el-option
      v-for="item in langs"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select></el-col>
  <el-col :span="1">&nbsp;</el-col>
  <el-col :span="1"><span class="login"><a href="http://www.e-to-china.com/member/member_sign.php">Login</a></span></el-col>
  <el-col :span="1"><div class="start">Get Started</div></el-col>
      <el-col :span="3">&nbsp;</el-col>
      </el-row>

 <div class="content">
 <div class="seq"></div>
        <el-row>
        <div class="titleone">
          One-Stop Solution
        </div>
      </el-row>
      <el-row>
          <div class="titletwo">
          <div class="fa">ForCross-Border <div class="yellowline"></div></div> Trade
          </div>
      </el-row>
      <el-row style="margin-top:36px">

        <div class="note">By the concept of “Facilitate Smooth Export to China”, ETCN takes on customs services as the core and digital technology as the approach to three core competencies, i.e. trade compliance risk control, trade service recommendation and trade digital empowerment.</div></el-col>

      </el-row>
      <el-row>
        <el-col :span="24" type="flex" justify="center">
          <a href="http://www.e-to-china.com/tradetool/business.html" style="text-decoration:none"><div class="btnlearn">Learn more</div></a>
        </el-col>
      </el-row>

    <el-row>
    <div class="outside">
    <!-- <el-carousel class="horse" height="424px">
      <el-carousel-item  v-for="item in imglist" :key="item.id">
          <img class="merry" :src="item.imgurl">
      </el-carousel-item>
    </el-carousel> -->

    <a href="http://hs.e-to-china.com/"><img class="merry" :src="taximg"></a>
    <div style="margin-top:55px;"></div>
        <div class="inside"></div>
        <div class= "backside">
          <div class="company">The most authoritative one-stop cross-border trade service company</div>
            <ul class="service">
              <el-row>

              <el-col :span="12">
                <li>Global Trade Digital Platform Empowerment</li>
                <li>Cross border trade one-stop integrated services</li>
              </el-col>

              <el-col :span="12">
                <li>Conference, exhibition and business opportunity docking services</li>
                <li>High level economic and trade rule consulting services</li>
              </el-col>
              </el-row>
            </ul>
        </div>
    </div>
    </el-row>
    <el-row>
      <el-col :span="24"><span class="core">Core Services</span>
      </el-col>
    </el-row>
    <el-row style="margin-top:60px;">
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="9" style="padding-right:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
                  <img  class="coreimg" :src="imgcore1">
              </div>
              <div class="plain">
              <div class="explain">
                <div class="slogan">Global Trade Data and Market Analysis</div>
                <ul class="expand">
                  <li>By Commodity</li>
                  <li>By Country/Region</li>
                  <li>By China Province/Region</li>
                  <li>By Buyer/ Supplier</li>
                </ul>
              </div>
              <span class="more"><a href="/#contact-form-box">more ></a></span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" style="padding-left:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
                <img  class="coreimg" :src="imgcore2">
              </div>
              <div class="plain">
              <div class="explain">
                <div class="slogan">Global Customs Commodity Classification</div>
                <ul class="expand">
                  <li>Global Commodity Classification</li>
                  <li>Cross-Border E-Commerce Batches Classification</li>
                  <li>Expert Commodity Classification Advisory Report</li>
                  <li>Intelligent Classification Interface Solution</li>
                </ul>
              </div>
              <span class="more"><a href="/#contact-form-box">more ></a></span>
                </div>
          </div>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
     <el-row style="margin-top:20px;">
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="9" style="padding-right:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
              <img  class="coreimg" :src="imgcore3"></div>
              <div class="plain">
               <div class="explain">
                 <div class="slogan">Global Tariff and Regulatory Information Consulting</div>
                 <ul class="expand">
                  <li>Global Tariff Inquiry</li>
                  <li>Global Regulatory Inquiry</li>
                  <li>FTA Tariff Planning</li>
                  <li>Info Dynamic Updates</li>
                </ul>
               </div>
               <span class="more"><a href="http://cis.e-to-china.com/">more ></a></span>
              </div>
          </div>
        </div>
      </el-col>

      <el-col :span="9" style="padding-left:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
              <img  class="coreimg" :src="imgcore4"></div>
              <div class="plain">
              <div class="explain">
                <div class="slogan">Trade Compliance and Risk Control</div>
                <ul class="expand">
                  <li>Commodity Compliance Database</li>
                  <li>Regulatory Updating Reminder</li>
                  <li>Declaration Form Review</li>
                  <li>Price and County of Origin Review</li>
                </ul>
              </div>
              <span class="more"><a href="http://cis.e-to-china.com/">more ></a></span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="9" style="padding-right:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
              <img  class="coreimg" :src="imgcore5"></div>
              <div class="plain">
              <div class="explain">
                <div class="slogan">China’s Import & Export Process Guidline</div>
                 <ul class="expand">
                  <li>Import & Export Process Inquiry</li>
                  <li>License Consulting</li>
                  <li>Expert Consulting</li>
                  <li>Service Provider Matching</li>
                </ul>
              </div>
             <span class="more"><a href="/#contact-form-box">more ></a></span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" style="padding-left:35px">
        <div class="out">
          <div class="smart">
              <div class="divimg">
              <img  class="coreimg" :src="imgcore6"></div>
              <div class="plain">
              <div class="explain">
                <div class="slogan">Marketing and Channel Connection</div>
                 <ul class="expand">
                  <li>Cross-Border Selection</li>
                  <li>Channel Connection</li>
                  <li>Industrial Connection</li>
                  <li>Conference, Exhibition and Training</li>
                </ul>
              </div>
              <span class="more"><a href="/#contact-form-box">more ></a></span>
              </div>
          </div>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
    <el-row style="margin-top:150px;clear:both; "></el-row>
    <div class = "logtwall">
        <el-row style="margin-top:100px"></el-row>
        <el-row>
          <el-col :span="24">
            <div class="typical">Typical Clients</div>
          </el-col>
          </el-row>
        <el-row>
          <el-col :span="24">
            <img :src="logowall">
          </el-col>
        </el-row>

    </div>

  <div class="footer" id="contact-form-box">
    <el-row>
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="8"><img class="banner" :src="bannerimg"></el-col>
      <el-col :span="5" class="contact">Contact us</el-col>
      <el-col :span="5" class="contact">Quick guidence</el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>


    <el-row>
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="8">&nbsp;</el-col>
      <el-col :span="5">
        <div class="sales">
            <span>Sales Phone</span>
            <span>(+86) (0) 10 64729034</span>

            <span class="mail">Sales Email / Sales Skype</span>
            <span>sales@e-to-china.net</span>
            <span class="mail">Service Center Email</span>
            <span>service@e-to-china.net</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="link">
            <span>CHINA HS CODE  SERCH</span>
            <span class="mail">CUSTOMS TARIFFS & RESTRICTIONS</span>
            <span class="mail">CHINA TRADE VALUE INQUIRY</span>
            <span class="mail">CHINA IMPORTERS</span>
            <span class="mail">CHINA EXPORTERS</span>
            <span class="mail">CHINA TADE DATE REPORT</span>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
    <div class="clear" style="margin-top:100px"></div>
    <el-row>
      <el-col :span="24">
      <div  class="icp">© 2009-2023 ETCN All rights reserved. ICP No.: Jing090265 京公网安备110105013206号</div>
      </el-col>
      </el-row>
    </div>
  </div>
  <!-- <div @click="close" class="cross" id="cross"><i class="el-icon-close"></i></div>
  <div class="customs" id="customs"><img class="china" :src=""></div> -->
  <div class="china">
      <img :src="imgcustoms"></img>
      <span class="fchina">China</span>
      <span class="fcustoms">Customs</span>
  </div>
</div>
</template>
<script>
  export default{
    data(){
      return{
        logo:require('../images/logo.png'),
        imgcustoms:require('../images/customslogo.png'),
        activeIndex: '1',
        language:"1",
        active:'',
        isfix:false,
        menucolor:'#f2f5f9',
        imgcore1:require('../images/icon1.png'),
        imgcore2:require('../images/icon2.png'),
        imgcore3:require('../images/icon3.png'),
        imgcore4:require('../images/icon4.png'),
        imgcore5:require('../images/icon5.png'),
        imgcore6:require('../images/icon6.png'),
        showheight:'',
        showtwoheight:'',
        showheightthree:'',
        showheightfour:'',
        showheightfive:'',
        showheightsix:'',
        langs:[
          {
            value:'1',
            label:'EN'
          },
          {
            value:'2',
            label:'CN'
          }
        ],
        imglist:[
          {
            id:1,
            imgurl:require('../images/tax2.png')
          },
          {
            id:2,
            imgurl:require('../images/tax2.png')
          },
          {
            id:3,
            imgurl:require('../images/tax2.png')
          },
        ],
        taximg:require('../images/tax2.png'),
        bannerimg:require('../images/banner.png'),
        logowall:require('../images/logowall.png'),
      }
    },
    mounted(){
      window.onscroll= this.handleScroll
    },
    methods: {
      handleSelect(key, keyPath) {
      },
      simuHover(){
        this.active = 'active';
      },
      hoverNone(){
        this.active = '';
      },


      showdiv(){
        this.showheight = 'colheight'
      },
      hidediv(){
        this.showheight = ''
      },

      showdivtwo()
      {
          this.showtwoheight = 'colheight'
      },
      hidedivtwo()
      {
          this.showtwoheight = ''
      },

      showdivthree()
      {
          this.showheightthree = 'colheight'
      },
      hidedivthree()
      {
          this.showheightthree = ''
      },
      showdivfour()
      {
          this.showheightfour = 'colheight'
      },
      hidedivfour()
      {
          this.showheightfour = ''
      },

      showdivfive()
      {
          this.showheightfive = 'colheight'
      },
      hidedivfive()
      {
          this.showheightfive = ''
      },
      showdivsix()
      {
          this.showheightsix = 'colheight'
      },
      hidedivsix()
      {
          this.showheightsix = ''
      },
      close(){
          document.getElementById("customs").style.display="none";
          document.getElementById("cross").style.display="none"
      },
      changeValue(value){
        if (value == 2)
        {
          location.href = "https://www.e-to-china.com.cn/"
        }
      },
      handleScroll(){
      if (document.documentElement.scrollTop>="86")
      {
        this.isfix = true;
        this.menucolor = "#ffffff";
        document.getElementById("language").style.backgroundColor="#ffffff";
      }
      else{
        this.isfix = false;
        this.menucolor = '#f2f5f9';
        document.getElementById("language").style.backgroundColor="#f2f5f9";
      }
    }
    }
  }

</script>
<style scoped="scoped">
.clear{
  clear:both;
}
.btnlearn{
  height:55px;
  width:170px;
  border-radius:6px;
  background-color:#4179bb;
  color:#fefefe;
  line-height:55px;
  margin: 42px auto 0px auto;
}
.main{
  height:86px;
  background-color:#f2f5f9;
  /* display:flex;
  flex-direction:column;
  justify-content:center; */
  line-height:86px;
  clear:both;
}
.content{
  background-color:#f2f5f9;
  z-index:-1000;
  position:relative;
  top: -10px;
}
.logo{
  width:280px;
  height:86px;
  line-height:86px;
  text-align:left;
}
.logo img{
  width:100%;
  height:28px;
  vertical-align:middle;
}
.main >>> .el-menu-item{
  font-family:"PingFangSC";
  font-size:16px;
  font-weight:600;
  border-bottom:none !important;
}
.main >>> .el-menu-item a {
  text-decoration: none;
}
.main >>> .el-menu-item:nth-child(3) a {
    height:100px;
    display:block;
}
.main >>> .el-menu-item:hover {
  background-color:#f2f5f9 !important;
  color: #00a8ff !important;
  border-bottom: none !important;
}
.main >>> .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none !important;;
}
.main >>> .el-menu--horizontal > .el-menu-item {
  height: 86px;
  line-height: 86px;
}
.main >>> .el-menu.el-menu--horizontal {
  border-bottom:none;
}

.content >>>.el-carousel__item{
  z-index:1000;
}
.content >>>.el-carousel__arrow{
  z-index:2000;
}
.show{
  position:absolute;
  top:70px;
  left:20px;
  text-align:left;
  display:none;
  z-index:10;
}
.active{
  display:block !important;
}
.show li{
  height:30px;
  line-height:30px;
  color:#586272;
}
.show li:hover{
  color:#409EFF;
}
.main >>> .el-input__inner{
  font-size:16px;
  color:#1f699f;
  width:80px;
  background-color:#f2f5f9;
  font-weight:600;
  border:none;
}
.main >>> .el-input__icon {
  color:#4179bb !important;
}
.login{
  /* color:#1f699f; */
  font-size:16px;
  line-height:86px;
  height:86px;
  display:block;
}
.login a{
  text-decoration:none;
  color:#1f699f;
}
.start{
  width: 120px;
  height: 40px;
  background-color: #4179bb;
  line-height: 40px;
  margin-top: 23px;
  border-radius: 6px;
  color:#fefefe;
}
.titleone{
  font-size:76px;
  font-weight:600;
  color:#1b202d;
  margin: 0 auto;
  font-family: Arial;
}
.titletwo{
  padding-top:10px;
  font-size:76px;
  font-weight:600;
  color:#4179bb;
  margin:0 auto;
  font-family: Arial;
}
.seq{
  padding-top:76px;

}
.fixed{
  background-color:#ffffff !important;
  position:fixed;
  left:0px;
  top:0px;
  width:100%;
}
.note{
    text-align: left;
    font-size: 16px;
    font-family: Arial;
    font-weight: 400;
    color: #586272;
    line-height:22px;
    width:1092px;
    margin:0 auto;
}
.fa{
  position:relative;
  display:inline-block;

}
.yellowline{
    position: absolute;
    top: 68%;
    left: 0px;
    border-bottom: 12px solid #f6dabb;
    width: 100%;
    z-index:-6;
    display:inline-block;
}
.merry{
  width:auto;
  height:424px;
  position:relative;
  z-index:1000;
  margin:55px  auto 0px auto;
}
.outside{
  position:relative;
  height:880px;
}
.inside{
  position:absolute;
  width:100%;
  height:300px;
  top:22px;
  background-repeat: repeat;
  background-image: url('../images/dot.png');
}
.backside{
  position:absolute;
  width:100%;
  height:446px;
  top:300px;
  background-color:#29303e;
}
.company{
  margin:150px auto 30px auto;

  font-size: 16px;
font-family: Arial;
font-weight: bold;
color: #FFFFFF;
}
.service{
  list-style:disc;
  display:inline-block;
  color:#ffffff;
  width:1092px;
  margin: 0 auto;
}
.expand{
  list-style:disc;
  margin-left:15px;
  margin-top:15px;
}
.expand li{
  color:#586272;
  line-height:20px;
  padding-bottom:10px;
  font-size:14px;
}
.explain{
  position: relative;
  max-width: 520px;
  display: block;
  width: 100%;
}
.service li{
  height:40px;
  text-align:left;
  text-decoration:underline;
  line-height:40px;
  font-family: Arial;
  font-weight: bold;
  font-size:16px;
  color: #FFFFFF;
  margin-left:25px;
}
.core{
  font-family:Arial;
  font-size:40px;
  font-weight:600;
  margin: 0 auto;
}
.out{
  text-align:left;
  border:2px solid #efefef;
}
.smart{
  padding:30px;
  overflow:hidden;
  background-color:#ffffff;
}
.slogan{
font-size: 18px;
font-family: Arial;
font-weight:bold;
color: #1B202D;
line-height: 20px;
width:100%;
height:50px;
}
.plain{
  float: left;
  position: relative;
  width: 80%;
}
.colheight{
  height:260px;
}
.coreimg{
  width:56px;
  height:56px;
  display:inline-block;

}
.more{
  font-size:14px;
  text-align:right;
  color:#4179bb;
  clear:both;
  line-height:18px;
  text-align:right;
  display:block;
}
.more a{
  text-decoration:none;
  color:#4179bb;
}
.contact{
  font-size:24px;
  text-align:right;
  font-family: Arial;
  font-weight: 400;
  color: #010101;
  line-height:24px;
}
.sales{
  width:100%;


  clear:both;
}
.sales span{
  display:block;
  height:20px;
  text-align:right;
  font-size: 14px;
font-family: Arial;
font-weight: 400;
color: #666666;
line-height: 18px;
}
.link{

  width:100%;


}
.link span{
  display:block;
  text-align:right;

  font-size: 14px;
font-family: Arial;
font-weight: 400;
color: #666666;
    line-height: 14px;
    height: 14px;
}
.mail{
  margin-top:25px;
}
.footer{
  background-color:#ffffff;
  padding-top:59px;
  border:1px solid #E6E6E6;
}
.icp{
  background-color:#29303e;
  font-size:14px;
  margin: 0 auto;
  height:80px;
  line-height:80px;
  color:#ffffff;
  margin-bottom:-10px;
  font-family: Arial;
  font-weight: 400;
}
.banner{
  width:110px;
  height:30px;
  text-align:left;
  display:block;
}
.china{
  width:150px;
  height:35px;
  display:block;
}
.customs{
  position:absolute;
  top:200px;
  right:30px;
}
.cross{
  position:absolute;
  top:150px;
  right:30px;
}

.logtwall{
  width:100%;
  background-color:#ffffff;
}
.logtwall img{
  width:82%;
  margin: 0 auto;
  display:block;
  height:370px;
  padding-bottom:38px;
}
.typical{
  color:#1b202d;
  font-size:40px;
  font-family:Arial;
  font-weight:600;
  padding-top:100px;
  padding-bottom:45px;
  color: #1B202D;
}
.china{
  position:absolute;
  top:0px;
  right:-0px;
width: 105px;
height: 87px;
background: #FFFFFF;
border-radius:0 0 0  100%;

}
.china img{
  position:absolute;
  top:15px;
  right:70px;
  width:22px;
  height:22px;
}
.fchina{
position:absolute;
  top:20px;
  right:9px;
  font-size: 14px;
font-family: Gill Sans;
font-weight: 400;
font-style: italic;
color: #F1AF50;
line-height: 14px;
}
.fcustoms{
position:absolute;
  top:40px;
  right:9px;
  font-size: 14px;
font-family: Gill Sans;
font-weight: 400;
font-style: italic;
color: #F1AF50;
line-height: 14px;
}
.horse{
  width:1092px;
  margin:55px  auto 0px auto;
}
.divimg{

  position:relative;
  width:86px;
  float:left;
}
</style>
<style>
.el-popper[x-placement^="bottom"] {
  margin-top:-12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue